import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { ContentCardModule } from '@app/library/content-card/content-card.module';
import { LibraryElementsModule } from '@app/library/library-elements.module';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { StatusBadgeComponent } from '@shared/layouts/status-badge/status-badge.component';
import { Content, ModerationStatusEnum } from 'lingo2-models';
import { AbstractContentPane } from '../models/abstract-content-pane';

@Component({
  selector: 'app-card-full-main',
  standalone: true,
  imports: [
    LocaleSharedModule,
    CommonModule,
    SpinnersModule,
    LibraryElementsModule,
    StatusBadgeComponent,
    ContentCardModule,
  ],
  templateUrl: './card-full-main.component.html',
  styleUrls: ['./card-full-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardFullMainComponent extends AbstractContentPane {
  public item: Content = null;

  protected init() {
    this.item = this.content.length ? this.content[0] : null;
  }

  protected onContentLoaded(viaQuery?: boolean): void {
    this.isVisible = !!this.content.length;
  }

  public get isOnModeration(): boolean {
    return this.item.moderation_status === ModerationStatusEnum.default;
  }

  public get isDeclined(): boolean {
    return (
      this.item.moderation_status === ModerationStatusEnum.softDeclined ||
      this.item.moderation_status === ModerationStatusEnum.hardDeclined
    );
  }
}
